module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1293.9e0ab5dc.png";